export default __webpack_public_path__ + "static/media/photo--sm--rene-2.e55675a4.jpg";